import React from "react";
import StyledH3Heading from "../../common/components/styledH3Heading/StyledH3Heading";
import StyledH6Heading from "../../common/components/styledH6Heading/StyledH6Heading";
import { useDashboardData } from "../../Hooks/api/useDashboardData";

const MarketplaceStatus = ({ custom  }) => {
  const {data } = useDashboardData()


  const Marketplace = [
    {
      views: data?.totalUsers,
      subject: "Users",
    },
    {
      views: data?.totalNfts,
      subject: "NFT's",
    },
    {
      views: data?.totalSoldNfts,
      subject: "Sold",
    },
  ];
  return (
    <div
      className={
        !custom
          ? "w-full sm:w-3/4 md:w-2/3 lg:w-4/5"
          : "ratingGradient yellow-border md:px-20 lg:px-6 xl:px-20 py-2 lg:w-[62.5%] xl:w-[65.5%]"
      }
    >
      <div
        className={
          !custom ? "flex flex-row justify-between" : "flex justify-around"
        }
      >
        {Marketplace.map((items, index) => (
          <div
            key={index}
            className="flex flex-col justify-center items-center"
          >
            <StyledH3Heading fontColor={"textGradient"}>
              {items.views}
            </StyledH3Heading>
            <StyledH6Heading>{items.subject}</StyledH6Heading>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketplaceStatus;
